// @ts-check
import React, { forwardRef } from "react"
import { Button as PrimeButton } from "primereact/button"

/** @type {React.FC<import("./Button.atom").Button>} */
const Button = forwardRef((props, ref) => {
  return <PrimeButton ref={ref} {...props} />
})

export default Button
